import { render, staticRenderFns } from "./TrendyolProductItems.vue?vue&type=template&id=3d068ea8&"
import script from "./TrendyolProductItems.vue?vue&type=script&lang=js&"
export * from "./TrendyolProductItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports